(() => {
  if (!customElements.get("pb-discovery-latest")) {
    customElements.define("pb-discovery-latest", class extends HTMLElement {
      async connectedCallback() {
        var _a;
        (_a = this.controller) == null ? void 0 : _a.abort();
        this.controller = new AbortController();
        this.setAttribute("aria-busy", "true");
        try {
          const url = new URL(this.dataset.url, location.origin);
          const preview = new URL(location.href).searchParams.get("preview_theme_id");
          if (preview) url.searchParams.set("preview_theme_id", preview);
          const response = await fetch(url, { signal: this.controller.signal, headers: { Accept: "text/html" } });
          if (!response.ok) return;
          const parsed = new DOMParser().parseFromString(await response.text(), "text/html");
          const row = parsed.querySelector("[data-discovery-products] > pb-footmuff-row");
          if (row && row.querySelector(".pb-fm__item") && this.isConnected) this.replaceChildren(row);
        } catch (error) {
          if (error.name !== "AbortError") this.dataset.loadState = "fallback";
        } finally {
          this.removeAttribute("aria-busy");
        }
      }
      disconnectedCallback() {
        var _a;
        (_a = this.controller) == null ? void 0 : _a.abort();
      }
    });
  }
})();
